import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpApi) // Para cargar archivos json via HTTP
  .use(LanguageDetector) // Para detectar idioma del navegador o localStorage
  .use(initReactI18next) // Para usar con React
  .init({
    fallbackLng: 'es',
    debug: false,
    interpolation: {
      escapeValue: false, // React ya hace el escape
    },
backend: {
  loadPath: '/locales/{{lng}}/traduccion.json',
},
  });

export default i18n;
